module.exports = __webpack_public_path__ + "img/100.10.ffa56517.png";